import i18n from "../../i18next/i18next";

export const eventTypes = () => {
  const { t } = i18n;
  return [
    {
      name: t("global:crm.email"),
      value: "EMAIL",
    },
    {
      name: t("global:crm.phone"),
      value: "PHONE",
    },
    {
      name: t("global:crm.meet"),
      value: "MEET",
    },
    {
      name: t("global:crm.meet_online"),
      value: "MEET_ONLINE",
    },
  ];
};
